<div>
  <div class="gb-dialog-header">
    <h1 translate="USERS.MESSAGE.TITLE"></h1>

    <button mat-icon-button mat-dialog-close>
      <gb-icon icon="close"></gb-icon>
    </button>
  </div>

  <div class="gb-dialog-content message-user-dialog-content">
    <p translate="USERS.MESSAGE.BODY"></p>

    <div class="message-placeholders">
      <div>
        <p translate="USERS.MESSAGE.PLACEHOLDER.CAMPAIGN_NAME_PLACEHOLDER"></p>
        <p translate="USERS.MESSAGE.PLACEHOLDER.CAMPAIGN_NAME"></p>
      </div>
      <div>
        <p translate="USERS.MESSAGE.PLACEHOLDER.FIRST_NAME_PLACEHOLDER"></p>
        <p translate="USERS.MESSAGE.PLACEHOLDER.FIRST_NAME"></p>
      </div>
      <div>
        <p translate="USERS.MESSAGE.PLACEHOLDER.LAST_NAME_PLACEHOLDER"></p>
        <p translate="USERS.MESSAGE.PLACEHOLDER.LAST_NAME"></p>
      </div>
    </div>

    <form [formGroup]="messageUserForm">
      <gb-form-field
        [control]="message_template"
        labelTranslateKey="USERS.MESSAGE.MESSAGE"
        type="textarea"
      ></gb-form-field>
    </form>
  </div>
  <div class="gb-dialog-actions-container">
    <button mat-flat-button (click)="submitForm()" [disabled]="(messageLoaded$ | async) === false">
      <gb-button-loader [loaded$]="messageLoaded$">
        <span translate="SEND"></span>
      </gb-button-loader>
    </button>
  </div>
</div>
